/****************************************************
 * Module Name:  workerSettings.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import WorkersettingsProxy from "../../utility/proxy/worker/workersettingsProxy";
import AddWorkersettingsModal from "./addWorkersettingsModal";
import { DataGridPro, GridToolbarExport, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import { Box, Button, Tooltip } from "@mui/material";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import renderCellExpand from "../common/dataGridCellExpand";
import Constants from "../../utility/constants";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import NoPermission from "../common/noPermission";
import PageTitle from "../common/pageTitle";

export class WorkersettingsMaster extends Component {
  constructor(props) {
    super(props);

    this.state = {
      workersettingss: [],
      showAddWorkersettingsModal: false,
      loadingButton: false,
      editOperation: false,
      sourceData: {},
      errorSnackbar: false,
      accesDenied: false,
      showWorkersettingsLoadSpinner: true,
      local_Permission: Constants.USER_PERMISSION.filter(
        (iPermission) =>
          iPermission.permissionid === Constants.PERMISSIONS.WORKER_SETTING
      ),
    };

    this.checkPermission()
  }

  componentDidMount() {
    PageTitle("WORKER_SETTING");
  }

  checkPermission = () => {
    let allowed = Utility.isReadAllowed(this.state.local_Permission)
    if (!allowed) {
      this.setState({
        accesDenied: true
      })
    } else {
      this.fetchWorkersettingsData(false);
    }
  }

  fetchWorkersettingsData = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showWorkersettingsLoadSpinner: true });
    WorkersettingsProxy.GetAllWorkersettings((responseData) => {
      if (responseData) {
        this.setState({
          workersettingss: responseData,
          showWorkersettingsLoadSpinner: false,
        })

      } else {
        this.setState({
          errorSnackbar: true,
          showWorkersettingsLoadSpinner: false,
        })
      }
    }
    );
  };

  columns = [
    {
      field: "id",
      headerName: "ID",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "settingkey",
      headerName: "KEY",
      headerAlign: "center",
      align: "center",
      flex: 1,
      renderCell: renderCellExpand,
    },
    {
      field: "settingvalue",
      headerName: "VALUE",
      headerAlign: "center",
      align: "center",
      flex: 1,
      renderCell: renderCellExpand,
    },
    {
      field: "settingdescription",
      headerName: "SETTING DESCRIPTION",
      headerAlign: "center",
      align: "center",
      flex: 2,
      renderCell: renderCellExpand,
    },
    {
      field: "edit",
      headerName: "EDIT",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <Box
            style={{ textAlign: "center", cursor: "pointer" }}
            onClick={() => {
              this.setState({
                showAddWorkersettingsModal: true,
                editOperation: true,
                sourceData: params.row,
              });
            }}
          >
            {" "}
            <BorderColorIcon color="primary" />
          </Box>
        );
      },
    },
  ];

  hideAddWorkersettingsModal = () => {
    this.setState({
      showAddWorkersettingsModal: false,
    });
  };

  handleValidation = (workersettingsData) => {
    //TODO do validation if needed here
    return true;
  };

  addWorkersettings = (workersettingsData) => {
    this.setState({ loadingButton: true });
    if (this.state.editOperation) {
      //Updating Workersettings, and once workersettings is updated on call refresh the list of current workersettingss
      WorkersettingsProxy.UpdateWorkersettings(
        workersettingsData,
        (response) => {
          if (response) {
            this.fetchWorkersettingsData(true);
            this.setState({ loadingButton: false });
            //Hidding workersettings modal
            this.hideAddWorkersettingsModal();
          } else {
            this.setState({ errorSnackbar: true });
            this.setState({ loadingButton: false });
          }
        }
      );
    } else {
      //Creating new Workersettings, and once workersettings is created on call refresh the list of current workersettingss
      WorkersettingsProxy.AddWorkersettings(workersettingsData, (response) => {
        if (response) {
          this.fetchWorkersettingsData(true);
          this.setState({ loadingButton: false });
          //Hidding workersettings modal
          this.hideAddWorkersettingsModal();
        } else {
          this.setState({ errorSnackbar: true });
          this.setState({ loadingButton: false });
        }
      });
    }
  };

  render() {
    const CustomToolbar = () => {
      return (
        <GridToolbarContainer
          sx={{
            display: "flex",
            alignItems: "center",
            marginHorizontal: "5px",
            "&.MuiDataGrid-toolbarContainer": {
              padding: "0px 4px !important",
            },
          }}
        >
          <GridToolbarColumnsButton />
          <GridToolbarFilterButton />
          <GridToolbarExport />
          <Box sx={{ flexGrow: 1, display: { sm: "none", md: "block" } }} />
          {this.state.showWorkersettingsLoadSpinner ? (
            <CircularProgress size="1rem" />
          ) : (
            <Tooltip title="Reload List">
              <RefreshOutlinedIcon
                color="primary"
                fontSize="medium"
                onClick={() => this.fetchWorkersettingsData(true)}
                sx={{ cursor: "pointer" }}
              />
            </Tooltip>
          )}

          {Utility.isAddAllowed(this.state.local_Permission) ? (
            <Tooltip title="Add Worker Settings">
              <Button
                color="info"
                variant="outlined"
                size="small"
                sx={{ ml: "5px" }}
                onClick={() =>
                  this.setState({
                    showAddWorkersettingsModal: true,
                    editOperation: false,
                    sourceData: {},
                  })
                }
                startIcon={<AddBoxOutlinedIcon size="large" />}
              >
                Worker Settings
              </Button>
            </Tooltip>
          ) : null}

          <GridToolbarQuickFilter debounceMs={500} />
        </GridToolbarContainer>
      );
    }
    let allowed = Utility.isReadAllowed(this.state.local_Permission)
    if (!allowed) {
      return <NoPermission />
    }
    const rows = this.state.workersettingss;
    const columns = Utility.isUpdateAllowed(this.state.local_Permission)
      ? this.columns
      : this.columns.filter((col) => col.field !== "edit");
    return (
      <Box>
        <br />
        {this.state.showAddWorkersettingsModal ? (
          <AddWorkersettingsModal
            Show={true}
            handleClose={this.hideAddWorkersettingsModal}
            handleSave={this.addWorkersettings}
            handleValidation={this.handleValidation}
            editOperation={this.state.editOperation}
            sourceData={this.state.sourceData}
            loading={this.state.loadingButton}
          />
        ) : (
          <Box />
        )}
        <CommonSnackbar
          show={this.state.errorSnackbar}
          message={<Box>{Constants.APiFailErrorMessage}</Box>}
          variant={"error"}
          autoHide={Constants.SnackBarCloseTimer}
          handleClose={() => this.setState({ errorSnackbar: false })}
          title="Failed"
        />
        <Box px={1}>
          <Box
            sx={{
              backgroundColor: '#fff',
              color: '#000',
              width: "100%",
              position: "relative",
              "& .MuiTablePagination-selectLabel": {
                marginTop: "15px",
              },
              "& .MuiTablePagination-displayedRows": {
                marginTop: "15px",
              },
              "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                fontWeight: Constants.defaultFontWeight,
              },
              "& .css-cc8tf1": {
                fontWeight: Constants.defaultFontWeight,
              },
              height: "85vh",
            }}
          >
            <DataGridPro
              disableRowSelectionOnClick={true}
              getRowHeight={() => "auto"}
              sx={{
                '& .MuiDataGrid-columnHeader': {
                  color: '#fff',
                  backgroundColor: 'grey',
                },
                "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                  py: "8px",
                },
                "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                  py: "15px",
                },
                "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                  py: "22px",
                },

                fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
              }}
              density="compact"
              slots={{ toolbar: CustomToolbar }}
              rows={rows}
              columns={columns}
              getRowId={(row) => row.id}
              loading={this.state.showWorkersettingsLoadSpinner}
              rowSpacingType="border"
              initialState={{
                columns: {
                  columnVisibilityModel: {
                    // Hide columns id , the other columns will remain visible
                    id: false,
                  },
                },
                pagination: {
                  paginationModel: Constants.pageSize,
                },
              }}
              pageSizeOptions={Constants.pageSizeOptions}
              pagination
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
            />
          </Box>
        </Box>
      </Box>
    );
  }
}

export default WorkersettingsMaster;
